import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

import Linear from 'app/componentV4/Progress/Linear'

const PollListTimeline = (props) => {
  const { data = [], total } = props

  const { formatMessage } = useIntl()

  return (
    <div className="space-y-10 my-10">
      {data.map((option) => (
        <div
          id={`preview-poll-${option.id}-${option.title}-card-view`}
          key={`${option.id}-${option.title}`}
        >
          <div className="flex justify-between items-end space-x-5">
            <Typography className="text-16 font-400 text-black">
              {option.title}
            </Typography>
            <Typography className="text-12 font-400 text-grey-300 whitespace-nowrap">
              {`${Math.round(option.votedPercentage)}% (${option.votedCount})`}
            </Typography>
          </div>
          <Linear variant="determinate" value={option.votedPercentage} />
        </div>
      ))}

      {total > data.length ? (
        <Typography className="text-12 font-400 text-grey-300">
          {`${formatMessage({ id: 'label.and.more' })} ...`}
        </Typography>
      ) : null}
    </div>
  )
}

PollListTimeline.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      votedPercentage: PropTypes.number,
      votedCount: PropTypes.number,
      imageURL: PropTypes.string,
    }),
  ),
  total: PropTypes.number,
}

export default PollListTimeline
